<app-simple-accordion id="accordion-promos" header="Acciones" [collapsed]="true">
  <div class="input-group" [formGroup]="rangeForm">
    <span class="input-group-text">Rango</span>
    <select class="form-control form-select" id="rangeStart" formControlName="start">
      <option value="">Inicio</option>
      <option *ngFor="let item of promos" [value]="item">{{ item }}</option>
    </select>
    <select class="form-select" id="rangeEnd" formControlName="end">
      <option value="">Fin</option>
      <option *ngFor="let item of promos" [value]="item">{{ item }}</option>
    </select>
  </div>
  <div class="row mt-2 align-items-end">
    <div class="col-auto">
      <button class="btn btn-success dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false"><i class="fas fa-file-csv me-1"></i>Descargar</button>
      <ul class="dropdown-menu">
        <li><button class="dropdown-item" type="button" (click)="downloadCsv()">Todas</button></li>
        <li><button class="dropdown-item" type="button" (click)="downloadCsvActives()">Activas</button></li>
        <li><button class="dropdown-item" type="button" [disabled]="selectedPromos.length < 1" (click)="downloadCsvFromList()">Seleccionadas</button></li>
        <li><button class="dropdown-item" type="button" [disabled]="rangeForm.invalid" (click)="downloadCsvRange()">Rango</button></li>
      </ul>
    </div>
    <div class="col-6 col-md-4">
      <label for="fileGroup" class="form-label">Agregar condición cliente</label>
      <input type="file" accept=".csv" class="form-control form-control-sm" id="fileGroup" #fileClientInput (change)="onFileClient($event)" />
    </div>
  </div>
</app-simple-accordion>
